import { initTestimonialsLogos } from "../modules/testimonials-logos.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTestimonialsLogos, { once: true });
} else {
  initTestimonialsLogos();
}
